import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

class VehicleSelectorAnalytics {
    static openAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.open;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static showVehicleNotProvidedLayer() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.showVehicleNotProvidedLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static hideVehicleNotProvidedLayer() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.hideVehicleNotProvidedLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static setVehicleNotProvidedCommentAction(comment) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setVehicleNotProvidedComment;

        setBehaviourEvent({category, action, label: comment});
        setFunnelyticsBehaviourEvent({category, action, label: comment});
    }

    static submitAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.submit;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static openFromConfiguratorAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.showVehicleConfiguratorFromConfiguratorLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static closeAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.close;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static setMakeAction(make) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setMake;

        setBehaviourEvent({ category, action, label: make });
        setFunnelyticsBehaviourEvent({ category, action, label: make });
    }

    static setModelAction(model) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setModel;

        setBehaviourEvent({ category, action, label: model });
        setFunnelyticsBehaviourEvent({ category, action, label: model });
    }

    static setYearAction(year) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setYear;

        setBehaviourEvent({ category, action, label: year });
        setFunnelyticsBehaviourEvent({ category, action, label: year });
    }

    static setSeriesChassisAction(seriesChassis) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setSeriesChassis;

        setBehaviourEvent({ category, action, label: seriesChassis });
        setFunnelyticsBehaviourEvent({ category, action, label: seriesChassis });
    }

    static setEngineAction(engine) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setEngine;

        setBehaviourEvent({ category, action, label: engine });
        setFunnelyticsBehaviourEvent({ category, action, label: engine });
    }

    static setDetailsAction(details) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setDetails;

        setBehaviourEvent({ category, action, label: details });
        setFunnelyticsBehaviourEvent({ category, action, label: details });
    }

    static setTyresAction(tyres) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setTyres;

        setBehaviourEvent({ category, action, label: tyres });
        setFunnelyticsBehaviourEvent({ category, action, label: tyres });
    }

    static setPostcodeAction(postcode) {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.setPostcode;

        setBehaviourEvent({ category, action, label: postcode });
        setFunnelyticsBehaviourEvent({ category, action, label: postcode });
    }

    static postcodeInvalid() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.postcodeInvalid;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static showInfoAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.showInfo;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static goToFormAction() {
        const category = GA_EVENTS.vehicleSelector.category;
        const action = GA_EVENTS.vehicleSelector.actions.goToForm;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
}

export default VehicleSelectorAnalytics;